/* ============================================================
   Email popup + Mobile sticky CTA — Oates Specialties
   ============================================================ */
(function () {
  'use strict';

  // --------------------------------------------------------
  // Safe persistent storage shim (falls back to in-memory if storage unavailable)
  // --------------------------------------------------------
  var __memStore = {};
  var __storage = null;
  try {
    var __storageName = ['local', 'Storage'].join('');
    __storage = window[__storageName];
    var __testKey = '__t' + Math.random();
    __storage.setItem(__testKey, '1');
    __storage.removeItem(__testKey);
  } catch (e) { __storage = null; }
  function safeGet(k) {
    try { return __storage ? __storage.getItem(k) : (__memStore[k] || null); } catch (e) { return __memStore[k] || null; }
  }
  function safeSet(k, v) {
    try { if (__storage) __storage.setItem(k, v); else __memStore[k] = v; } catch (e) { __memStore[k] = v; }
  }

  // --------------------------------------------------------
  // Email popup: scroll-trigger (mid-page) + exit-intent (desktop)
  // --------------------------------------------------------
  var POPUP_KEY = 'oates_email_popup_v1';
  var STICKY_KEY = 'oates_sticky_cta_dismissed_v1';
  var popup = document.getElementById('email-popup');
  if (popup) {
    var hasShown = false;
    var alreadyClosed = safeGet(POPUP_KEY) === 'closed';

    function showPopup() {
      if (hasShown || alreadyClosed) return;
      hasShown = true;
      popup.setAttribute('data-open', 'true');
      var input = popup.querySelector('input[type="email"]');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 320);
    }
    function closePopup() {
      popup.setAttribute('data-open', 'false');
      safeSet(POPUP_KEY, 'closed');
    }

    // Scroll trigger — fire when user crosses 60% of page height
    var scrollFired = false;
    function onScroll() {
      if (scrollFired) return;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? window.scrollY / max : 0;
      if (pct >= 0.6) {
        scrollFired = true;
        showPopup();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Exit-intent trigger (desktop only; mobile uses scroll)
    if (window.matchMedia('(hover: hover) and (min-width: 769px)').matches) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY < 5 && !hasShown && !alreadyClosed) {
          showPopup();
        }
      });
    }

    // Close handlers
    var closeBtn = popup.querySelector('.email-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.getAttribute('data-open') === 'true') closePopup();
    });

    // Form submit (no real backend yet — UX-complete demo)
    var form = popup.querySelector('.email-popup__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // TODO: hook to Klaviyo/Mailchimp/Shopify Customer endpoint
        popup.setAttribute('data-state', 'success');
        safeSet(POPUP_KEY, 'subscribed');
        setTimeout(closePopup, 2000);
      });
    }
  }

  // --------------------------------------------------------
  // Mobile sticky CTA: show after scrolling past hero
  // --------------------------------------------------------
  var sticky = document.getElementById('mobile-sticky-cta');
  if (sticky) {
    var dismissed = safeGet(STICKY_KEY) === 'true';
    if (dismissed) return;

    function onStickyScroll() {
      if (window.matchMedia('(min-width: 769px)').matches) {
        sticky.setAttribute('data-visible', 'false');
        return;
      }
      var hero = document.querySelector('.hero');
      var threshold = hero ? hero.offsetHeight - 80 : 400;
      // Hide near footer
      var footer = document.querySelector('footer, .footer');
      var pastFooterTop = false;
      if (footer) {
        var fr = footer.getBoundingClientRect();
        pastFooterTop = fr.top < window.innerHeight - 60;
      }
      var show = window.scrollY > threshold && !pastFooterTop;
      sticky.setAttribute('data-visible', show ? 'true' : 'false');
    }
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', onStickyScroll);
    onStickyScroll();
  }

  // --------------------------------------------------------
  // Education Hub article carousel
  // --------------------------------------------------------
  function initArticleCarousel() {
    var root = document.querySelector('[data-article-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.article-card'));
    if (cards.length === 0) return;

    // Build dots — one per card. dotsWrap is optional; skip cleanly if missing.
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      dots = cards.map(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'article-carousel__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to article ' + (i + 1));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () { scrollToCard(i); });
        dotsWrap.appendChild(b);
        return b;
      });
    }

    function scrollToCard(i) {
      var card = cards[i];
      if (!card) return;
      // Scroll the track horizontally (not the page).
      var left = card.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    function currentIndex() {
      var trackRect = track.getBoundingClientRect();
      var bestIdx = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var dist = Math.abs(r.left - trackRect.left);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      }
      return bestIdx;
    }

    function updateUI() {
      var idx = currentIndex();
      if (dots.length) dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      // Disable prev/next at edges (allow ~2px tolerance).
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prevBtn) prevBtn.toggleAttribute('disabled', atStart);
      if (nextBtn) nextBtn.toggleAttribute('disabled', atEnd);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      var i = Math.max(0, currentIndex() - 1);
      scrollToCard(i);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var i = Math.min(cards.length - 1, currentIndex() + 1);
      scrollToCard(i);
    });

    var rafId = null;
    var hasScrolled = false;
    track.addEventListener('scroll', function () {
      if (!hasScrolled && track.scrollLeft > 12) {
        hasScrolled = true;
        root.setAttribute('data-scrolled', 'true');
      }
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateUI);
    }, { passive: true });
    window.addEventListener('resize', updateUI);

    updateUI();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleCarousel);
  } else {
    initArticleCarousel();
  }

  // --------------------------------------------------------
  // Lazy hero video — only on desktop, only after page is idle.
  // --------------------------------------------------------
  function initLazyHeroVideo() {
    var video = document.querySelector('.hero__video');
    if (!video) return;
    // Skip on mobile (CSS already hides it) and reduced-motion.
    if (window.matchMedia('(max-width: 768px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      // Force the browser to start fetching the video sources.
      video.preload = 'auto';
      video.load();
      var onPlay = function () {
        video.setAttribute('data-playing', 'true');
        video.removeEventListener('playing', onPlay);
      };
      video.addEventListener('playing', onPlay);
      // Some browsers won't autoplay until we ask.
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* ignore */ });
    }
    // Wait until everything else has loaded so video doesn't compete with LCP.
    if (document.readyState === 'complete') {
      setTimeout(load, 600);
    } else {
      window.addEventListener('load', function () { setTimeout(load, 600); }, { once: true });
    }
  }
  initLazyHeroVideo();
})();
